export default "__VITE_ASSET__X2oL7AgJ__"